const filtersPopin = () => {

  const pageBody = document.body
  const filterOpenBtn = document.querySelector('.car-filters__button')
  const filterCloseBtn = document.querySelector('.car-filters__close-btn')
  const filterList = document.querySelector('.filter-left .car-filters__list')
  const validateBtn = document.querySelector('.btn-validate')

  return {
    togglePopin: () => {
      if (filterOpenBtn) {
        filterOpenBtn.addEventListener('click', () => {
          if (!filterList.classList.contains('open')) {
            pageBody.classList.add('open')
            filterList.classList.add('open')
          }
        })
        filterCloseBtn.addEventListener('click', () => {
          if (filterList.classList.contains('open')) {
            pageBody.classList.remove('open')
            filterList.classList.remove('open')
          }
        })
        validateBtn.addEventListener('click', () => {
          if (filterList.classList.contains('open')) {
            pageBody.classList.remove('open')
            filterList.classList.remove('open')
          }
        })
      }
    },
  }
}
export default filtersPopin
